export const en = {
    menu: {
        about: "About",
        privacy: "Privacy",
        terms: "Terms",
        contactUs: "Contact Us",
        DazWayWeb: "{{APP_NAME}} Web",
        home: "Home",
        help: "Help",
        policy: "Policy",
        policySubMenu: {
            staySafe: "Stay Safe ",
            childProtection: "Child Protection "
        },
        helpSubMenu: {
            deleteAccount: "Delete Account",
            manageProfile: "Manage Profile",
            featuresToCommunicate: "Features to Communicate",
            profileCreation: "Profile Creation",
            editProfileFeatures: "Edit Profile Features",
            createAndSharePost: "Chats",
            exploreAndViewPost: "Calls",
            chatsAndCalls: "Meetings",
            updateAccount: "Update Your Account Settings",
            interest: "Modify Your Home Feed Interest",
            notification: "Notification Settings",
            language: "Switch the Language",
            linkAccount: "Link Account with Web Page",
            inviteFriends: "Invite Your Friends",
            logout: "Logout of DazWay",
            settings: "Adjust Your Settings"
        }
    },
    pages: {
        contactUs: {
            title: "Contact Us",
            desc: "We're here to help! If you have any questions, feedback, or need assistance, please don't hesitate to reach out. You can contact us through any of the following methods"
        },
        address: {
            label: "Mailing Address",
            value1: "DazWay Pay",
            value2: "7 Bell Yard, London, England, WC2A 2JR"
        },
        home: {
            mainBanner: {
                title: "Stay Connected Anytime, Anywhere",
                desc: "Connect with friends, family, or teammates—seamlessly and securely.",
                features: {
                    chatInstantly: "Chat Instantly",
                    crystalClearCalls: "Crystal-Clear Calls ",
                    hdVideoAnywhere: "HD Video Anywhere"
                },
                cardSection1: {
                    title: "Connect Seamlessly, Anytime, Anywhere",
                    desc: "Real-time messaging with photos, emojis, and more. Your conversations, your way — all in one place."
                },
                cardSection2: {
                    title: "Share Confidently with End-to-End Encryption",
                    desc: "Talk freely—your messages, calls, and video chats are protected with powerful end-to-end encryption."
                },
                cardSection3: {
                    title: "Stay Close, No Matter the Distance",
                    desc: "Whether it’s a group catch-up or a quick hello, enjoy high-quality voice and video calls that bring you closer."
                }
            },
            banner1: {
                title: "Never Miss a Moment with Voice and Video Calls",
                desc: "From group calls with friends to quick check-ins with family, enjoy crystal-clear voice and video that make you feel like you’re in the same room."
            },
            banner2: {
                title: "Stay Close, No Matter the Distance",
                desc: "Dive into a world of photos, videos, and profiles tailored to your interests. Discover and connect with new content effortlessly."
            },
            banner3: {
                title: "Capture and Share Your Everyday Moments",
                desc: "From a group call to classmates to a quick call with mom, feel like you're in the same room with voice and video calls."
            }
        },

    },
    genericContent: {
        email: "Email",
        phoneNumber: "Phone Number",
        mailingAddress: "Mailing Address",
        joinDaz: "Join {{APP_NAME}}",
        note: "Note",
        or: "OR"
    },
    aboutPage: {
        title: "About DazWay",
        heading:
            "Welcome to DazWay App – Redefining Secure and Expressive Communication",

        description:
            "DazWay App is the next-generation platform for seamless, secure, and expressive digital communication. Whether you’re connecting with friends, family, or colleagues, DazWay offers a refined experience with real-time messaging, high-definition audio/video calls, and intelligent sharing features — all within a sleek, modern interface.",

        keyFeatures: "Key Features:",

        features: {
            realTimeMessaging: {
                title: "Real-Time Messaging",
                desc:
                    "Instantly chat with typing indicators, read receipts, and a smooth message flow.",
            },

            hdCalls: {
                title: "HD Audio & Video Calls",
                desc:
                    "Make high-quality, end-to-end encrypted audio and video calls from anywhere in the world.",
            },

            mediaSharing: {
                title: "Media & File Sharing",
                desc:
                    "Easily share photos, videos, voice notes, and documents with a few taps.",
            },

            emojis: {
                title: "Emojis & Reactions",
                desc:
                    "Express yourself with a wide variety of emojis and instant message reactions.",
            },

            liveLocation: {
                title: "Live Location Sharing",
                desc:
                    "Share your location in real-time with trusted contacts for added convenience and safety.",
            },

            modernUi: {
                title: "Modern UI/UX",
                desc:
                    "Enjoy a fast, intuitive, and clean design tailored for both personal and professional use.",
            },

            scheduledMessages: {
                title: "Scheduled Messages",
                desc:
                    "Plan and send messages automatically at your preferred date and time without missing important conversations.",
            },

            disappearingMessages: {
                title: "Disappearing Messages",
                desc:
                    "Keep chats private by automatically removing messages after the selected time duration.",
            },

            editingTools: {
                title: "Basic Editing Tools",
                desc:
                    "Edit and personalize your photos and videos with simple tools like crop, rotate, draw, and text before sharing.",
            },

            frenchLocalization: {
                title: "French Localization",
                desc:
                    "Experience the application interface in French with localized menus, labels, messages, and user flows for improved accessibility and usability.",
            },
        },

        footerDescription:
            "DazWay App is more than just a chat tool — it’s your secure digital companion, built to protect your privacy and enhance the way you connect and communicate.",

        downloadText:
            "Download the DazWay App today and experience the future of digital communication.",
    },
    privacy: {
        title: "Privacy Policy",

        introduction: {
            title: "1. Introduction",
            englishNotLegalese: {
                title: "1.1 English, Not Legalese",
                desc1:
                    "Privacy is important, and we want you to understand the issues involved. We've chosen to use plain English as much as possible to make our terms clear. Some sections still have room for improvement - we plan to tackle these over time.",
                desc2:
                    "Where you read 'DazWay' it refers to all services made available at",
                service1:
                    "The DazWay chat app, a Pareza Limited platform which you can use to connect to any server that implements the Pareza Limited protocol;",
                service2:
                    "The Pareza Limited developer communication app;",
                service3:
                    "The purchase, provisioning, configuration, monitoring, and management of hosted homeservers and associated services via DazWay Pareza Limited Services, or the DazWay app store.",
                homeserver:
                    "Where you read 'homeserver', 'homeservers' or 'the Homeserver', it refers to the services configured within DazWay which store the user account and personal conversation history, provide additional functionality such as bots and bridges, and (where enabled by the Customer) communicate via the open Pareza Limited decentralized communication protocol with the public Pareza Limited Network.",
                serviceDescBefore:
                    "When you read 'the Service' in this document, it refers to the DazWay chat app instances exposed on",
                serviceDescAfter:
                    "(or subdomains) by Pareza Limited.",
                companyDesc:
                    "Where you read 'DazWay' or 'we' or 'us' below, it refers to DazWay, a trading name of Pareza Limited.",
                controller:
                    "DazWay is the Data Controller for your data. ",
                controllerData: "We can be contacted as per below:",
                contact:
                    "Should you have other questions or concerns about this document, please email us at",
                postalAddress: {
                    label: "Postal address:",
                    company: "DazWay Pay",
                    address: "7 Bell Yard, London, England, WC2A 2JR",
                },
            },

            scope: {
                title: "1.2 Scope of This Document",
                desc:
                    "This document explains how we process personal data, as it relates to:",
                user:
                    "DazWay chat app users use DazWay to connect to any server that implements the SCPT Protocol.",
                customer:
                    "DazWay Customers use DazWay SCPT Services to provision and manage hosted homeservers. Apart from where otherwise noted, this document does not address data protection issues relating to the messaging and file data submitted by Users to the hosted homeserver instances, as this is the legal responsibility of the Customer.",
            },

            customerUser: {
                title: "1.3 The Customer and the User",
                desc1:
                    "This document is designed to explain Data Protection issues relating to DazWay Customers and Users. Put simply, you're a Customer if you're paying (or otherwise compensating) DazWay to provide a dedicated hosted messaging service. If you have an account registered on a homeserver that you use to send and receive messages, or use the DazWay chat app to connect any server within the SCPT Protocol, you are a User.",
                desc2:
                    "It is possible to be both a Customer and a User, but we encourage you to consider these roles separately when thinking about Data Protection concerns.",
            },

            changes: {
                title: "1.4 Changes to This Document",
                desc1:
                    "Over time, we may make changes to this document. If we make a material change, we will provide the Customer with reasonable notice prior to the change. We will set forth the date upon which the changes will become effective; any use of DazWay by the Customer, or any use of a hosted homeserver from SCPT by a User will constitute the Customer's acceptance of these changes.",
                desc2:
                    "Your access and use of DazWay are always subject to the most current version of this document.",
            },
        },

        accessData: {
            title: "2. Access to Your Data",

            legalBasis: {
                title:
                    "2.1 What is the legal basis for processing my data and how does this affect my rights under GDPR (General Data Protection Regulation)?",
                subTitle: "2.1.1 Legal Basis for Processing",
                desc:
                    "DazWay has different legal basis for processing, based on which product you are using:",
                chatUsers:
                    "We collect your IP address when you request access to the DazWay client from our web server. This data is collected under Legitimate Interest, to support operational maintenance and to protect against malicious actions against our infrastructure.",
            },

            dataOwnership: {
                title:
                    "2.1.2. Data Ownership - Messaging and File data within hosted homeservers",
                desc1:
                    "The Customer can use DazWay to provision and manage hosted homeservers. The Customer owns and controls all messages and files submitted to their homeserver by User accounts registered natively on their homeserver. This ownership does not extend to messages and files submitted over federation or bridging",
                desc2:
                    "This means that, in addition to the usual data access controls defined by the SCPT, all unencrypted messages and files can be accessed by the Customer, and that access is retained even if no User account within the system retains access to the data.",
            },

            rights: {
                title: "2.1.3. Your rights as Data Subject",
                desc:
                    "You have rights in relation to the personal data we hold about you. Some of these only apply in certain circumstances. Some of these rights are explored in more detail elsewhere in this document. For completeness, your rights under GDPR are:",
                right1: "The right to be informed",
                right2: "The right of access",
                right3: "The right to rectification",
                right4: "The right to erasure",
                right5: "The right to restrict processing",
                right6: "The right to data portability",
                right7: "The right to object",
                right8:
                    "Rights in relation to automated decision making",
                right9: "For more information about these rights, please see the guidance provided by the ICO. If you have any questions or are unsure how to exercise your rights, please contact us at",
            },

            collectInfo: {
                title:
                    "2.2 What information do you collect about me and why?",
                desc:
                    "The information we collect is for the purpose of supporting your management of hosted homeservers through DazWay Services, or to support operational maintenance of the DazWay client. We do not profile homeserver Users or their data, but we might profile metadata pertaining to the configuration and management of hosted homeservers so that we can improve our products and services.",
            },

            profileInfo: {
                title: "2.2.1 Information you provide to us:",
                desc: "We collect information about you when you input it to the DazWay or SCPT Services apps or otherwise provide it directly to us.",
                subTitle: "DazWay Profile Information",
                desc1: "When you register and use our App, we may collect the following personal information:",
                name: "Name: To identify and personalize your account.",
                email:
                    "Email address: To communicate with you, send updates, and verify your account.",
                phone:
                    "Phone number: To connect you with your contacts and for security purposes.",
                profile:
                    "Profile picture: To personalize your account.",
                contacts:
                    "Contacts:  With your consent, we may access your contact list to help you connect with friends who also use DazWay.",
            },

            authentication: {
                identifier:
                    "Your authentication identifier is used to authenticate your access to DazWay at",
                identifierId: "and to uniquely identify you.",
                twoFactor:
                    "You will be given the choice to set up 2-Factor Authentication to secure your account. For 2FA over SMS, we will require your phone number. This information will be shared with a SMS service provider.",
            },

            homeAccountSetup: {
                title: "DazWay Home Account Setup",

                desc1:
                    "When setting up an DazWay Home account via the setup wizard, we will temporarily access your account data, in order to migrate your existing DazWay account to your new DazWay Home account. This includes:",

                joinedGroups:
                    "List of groups you have joined",

                powerLevels:
                    "Power levels in those groups",

                avatar:
                    "Your avatar",

                desc2:
                    "The setup wizard will also request your OpenID and access token, in order to retrieve your name and verified phone number and/or email address. This information will be temporarily sent to our backend, but will not be retained following your setup completion.",
            },

            connectionInfo: {
                title: "2.2.2 Information we collect automatically as you use the service:",
                subTitle: "Connection Information",
                desc:
                    "We log the IP addresses of everyone who accesses DazWay. This data is used in order to mitigate abuse, debug operational issues, and monitor traffic patterns. Our logs are kept for:",
                desc2: "180 days, for DazWay Super chat app IP addresses;",
            },

            usageInfo: {
                title: "Usage Information",
                desc1:
                    "We track usage data for DazWay hosting services. When you are signed in to your account we may track your usage of the site and associate that information with your account details. This data helps us understand how our users are using the application so that we can make improvements to the Service.",
                desc2: "If you are using the DazWay chat app, you will be asked to opt-in to this anonymised data collection. Your use of the Service does not rely on your opt-in to this. When using any of the DazWay chat clients after opt-in, your visit to the service will be logged, alongside your device ID and agent. This allows us to understand usage patterns based on each platform. The mapping of this data is logged for 28 days - from this point on only aggregated data is kept, for operational and statistical purposes. For further details on our collection and usage of analytics data, please see our Cookie Policy.",
                desc3: "When reporting errors we might collect some information to help us find a solution. This may include your IP address, hostname, full name and email address. This information is collected in the application monitoring platform Sentry and is subject to strict retention policies"
            },

            locationInfo: {
                title: "Location Information",
                desc1:
                    "We may collect location data on you, if you choose to use the static or live location sharing features within the DazWay app. This includes your longitude, altitude and latitude data in order to accurately calculate your precise location.",
                desc2:
                    "Location data is held within the group in which it is shared, so it will be encrypted in encrypted rooms and not encrypted in rooms where encryption is switched off. You will be shown a disclaimer during your first time using this feature, but please apply caution and consideration when sharing your personal data within the app.",
                desc3: "The DazWay clients use the third-party service MapTiler to provide the images used to display maps."
            },


            sharingData: {
                title:
                    "2.3. Sharing Data in Compliance with Enforcement Requests and Applicable Laws; Enforcement of Our Rights",

                desc1:
                    "In exceptional circumstances, we may share information about you with a third party if we believe that sharing is reasonably necessary to:",

                lawCompliance:
                    "Comply with any applicable law, regulation, legal process or governmental request,",

                securityProtection:
                    "Protect the security or integrity of our products and services (e.g. for a security audit),",

                protectUsers:
                    "Protect DazWay and our users from harm or illegal activities, or",

                emergencyResponse:
                    "Respond to an emergency which we believe in good faith requires us to disclose information to assist in preventing the serious bodily harm of any person.",
            },

            passwords: {
                title: "2.4 How do you handle passwords?",
                desc1:
                    "We never store password data in plain text; instead they are stored hashed (with at least 12 rounds of bcrypt, including both a salt and a server-side pepper secret). Passwords sent to the server are encrypted using SSL.",
                desc2:
                    "It is your sole responsibility to keep your user name, password and other sensitive information confidential. Actions taken using your credentials shall be deemed to be actions taken by you, with all consequences including service termination, civil and criminal penalties.",
                desc3: "If you become aware of any unauthorised use of your account or any other breach of security, you must notify DazWay immediately by sending an email to",
                desc4: "Users should manage good password hygiene (e.g. using a password manager) and change their password if they believe their account is compromised.",
                desc5: "If you forget your password (and you have registered an email address) you can use the password reset facility to reset it."
            },

            childrenPrivacy: {
                title: "2.5 Our commitment to Children's Privacy",
                desc:
                    "We never knowingly collect or maintain information in DazWay, through any of the Services provided, from those we know are under 16, and no part of DazWay is structured to attract anyone under 16. If you are under 16, please do not use the Service.",
            },

            accessCorrect: {
                title:
                    "2.6 How can I access or correct my information?",
                desc:
                    "If you are a user of the DazWay chat app you can request a copy of your data by emailing info@dazway.im. We are working on a solution which will allow you to download the data automatically.",
            },

            guidelines: {
                title:
                    "2.7. What are the Guidelines DazWay follows when accessing my data?",

                desc1:
                    "We restrict who at DazWay (employees and contractors) can access DazWay non-encrypted data to roles which require access in order to maintain the health of the DazWay apps and services.",

                desc2:
                    "We never share what we see with other users or the general public.",
            },

            whoHasAccess: {
                title: "2.8. Who else has access to my Data?",

                desc1:
                    "We host the DazWay Services on Amazon Web Services (AWS), specifically:",

                adminServer:
                    "Our admin server is hosted in an AWS data centre in Ireland",

                deploymentServer:
                    "Our deployment server is hosted in an AWS data centre in Ireland.",

                desc2:
                    "Amazon employees may have access to some of this data. Here's Amazon's privacy policy. Amazon controls physical access to their locations.",
            },

            dataProtection: {
                title:
                    "2.10. How is my Data protected from another user's Data?",

                desc1:
                    "All of the DazWay user data resides within the same dedicated cluster. We use software best practices to guarantee that only the Customer can access it. In other words, we segment User data via software. We do our best and are very confident we're doing a good job at it, but, like every other service that hosts User data on the same database, we cannot guarantee that it is immune to a sophisticated attack.",
            },

            security: {
                title:
                    "2.12 What should I do if I find a security vulnerability in the service?",
                desc1:
                    "If you have discovered a security concern, please email us at",
                desc2: "We'll work with you to make sure that we understand the scope of the issue, and that we fully address your concern. Information security is our highest priority, and we work to address any issues that arise as quickly as possible.",
                desc3:
                    "Please act in good faith towards our users' privacy and data during your disclosure. White hat security researchers are always appreciated.",
            },
            reportStatus: {
                title:
                    "2.13 How can a user report a Status Update (Stories)?",
                policyTitle: "The Policy:",
                policyDesc:
                    "Just as with standard messages, other users or third parties can report your status updates to Dazway for potential violations of Terms or local laws.",
                actionTitle: "Action Taken:",
                actionDesc:
                    "When a report is submitted, Dazway's safety systems collect information about both the reporting party and the reported user, including associated status updates, to investigate the violation.",
            },
        },

        complaint: {
            title: "3. Making a Complaint",
            desc1:
                "We try to meet the highest standards when collecting and using personal information. For this reason, we take any complaints we receive about this very seriously. We encourage people to bring it to our attention at",
            desc2:
                " if they think that our collection or use of information is unfair, misleading or inappropriate. We would also welcome any suggestions for improving our procedures.",
            desc3: "If you want to make a complaint about the way we have processed your personal information to the supervisory authority, you can contact the ICO (the statutory body which oversees data protection law) at"
        },
    },

    terms: {
        title: "Terms and Conditions - DazWay App",

        effectiveDate: "Effective Date:",
        effectiveDateValue: "May 20, 2025",

        intro1:
            "Welcome to DazWay App, a multifunctional mobile application provided by Pareza Limited, a company registered in the United Kingdom, with its registered office at 77 Bell Yard, London, England, WC2A 2JR ('we,' 'us,' or 'our').",

        intro2:
            "By using DazWay App, you agree to be bound by these Terms and Conditions, along with our Privacy Policy. If you do not agree, please do not use the App.",

        eligibility: {
            title: "1. Eligibility",

            desc1:
                "You must be at least 13 years old to use DazWay App. If you are under the legal age of majority in your country, you must use the App under the supervision and consent of a parent or legal guardian.",
        },

        services: {
            title: "2. Description of Services",

            desc1:
                "DazWay App provides a wide range of digital communication and lifestyle features, including:",

            instantMessaging: "Instant Messaging (Chat)",

            voiceVideoCalling: "Voice and Video Calling",

            airtimeTopup:
                "Airtime Top-Up (via third-party integration)",

            marketplace:
                "Marketplace for goods and services",

            publicNews:
                "Public News and Announcements",

            ekyc:
                "Identity Verification (eKYC) features",

            desc2:
                "The App may evolve with new features or services added, modified, or removed over time.",
        },

        registration: {
            title: "3. Account Registration",

            desc1:
                "To use certain features, users must create an account by providing accurate and complete information. You are solely responsible for keeping your login credentials secure and for any activity under your account.",

            desc2:
                "We reserve the right to suspend or terminate your account at our discretion in cases of misuse, fraud, or violations of these Terms.",
        },

        acceptableUse: {
            title: "4. Acceptable Use Policy",

            desc1:
                "When using DazWay App, you agree to the following:",

            illegalContent:
                "Do not share illegal, abusive, violent, or misleading content",

            harassment:
                "Do not harass, threaten, or impersonate others",

            rightsViolation:
                "Do not violate the rights of others (e.g., intellectual property, privacy)",

            appSecurity:
                "Do not interfere with or compromise the App's security or functionality",

            desc2:
                "Any violation of this policy may lead to account suspension or permanent removal from the platform.",
        },

        marketplace: {
            title: "5. Marketplace Usage",

            desc1:
                "The DazWay App marketplace allows users to browse, post, or promote goods and services.",

            noParty:
                "We do not act as a party to transactions unless otherwise stated.",

            userResponsibility:
                "Users are solely responsible for the accuracy and legality of their listings.",

            disputes:
                "We are not liable for disputes between buyers and sellers, though we may assist in mediation where possible.",
        },

        intellectualProperty: {
            title: "6. Intellectual Property",

            desc1:
                "All materials in DazWay App, including software, text, images, graphics, and logos are the property of Pareza Limited or licensed third parties.",

            desc2:
                "You may not copy, reproduce, modify, or distribute any part of the App unless authorized in writing by Pareza Limited.",
        },

        privacyData: {
            title: "7. Privacy and Data",

            desc1:
                "We take user privacy seriously. Your personal data is collected and processed in accordance with our Privacy Policy. This includes identity data for user verification, communication history, and usage logs for operational and security purposes.",

            desc2:
                "Data may be processed and stored outside your country of residence, in accordance with applicable data protection laws.",
        },

        availability: {
            title: "8. Availability and Modifications",

            desc1:
                "We strive to maintain continuous access to the App, but we do not guarantee uninterrupted availability. We may update, suspend, or discontinue certain features at any time without prior notice.",

            desc2:
                "We are not responsible for any losses or damages caused by outages or technical issues.",
        },

        termination: {
            title: "9. Termination",

            desc1:
                "We reserve the right to terminate or suspend your access to DazWay App at our discretion, with or without notice, particularly in cases of violations of these Terms or applicable laws.",

            desc2:
                "You may delete your account at any time by using the in-app options or by contacting support.",
        },

        disclaimer: {
            title: "10. Disclaimer and Limitation of Liability",

            desc1:
                "DazWay App is provided on an 'as-is' and 'as-available' basis.",

            desc2:
                "To the maximum extent permitted by law, Pareza Limited disclaims any liability for:",

            dataLoss:
                "Loss of data or content",

            serviceInterruptions:
                "Unavailability or interruptions of service",

            misconduct:
                "Damages from user misconduct or third-party actions",

            indirectDamages:
                "Any indirect, incidental, or consequential damages",
        },

        changes: {
            title: "11. Changes to These Terms",

            desc1:
                "We may revise these Terms from time to time. Users will be notified through the App or by email of any material changes. Continued use of DazWay App following changes constitutes your acceptance of the new terms.",
        },

        governingLaw: {
            title: "12. Governing Law and Jurisdiction",

            desc1:
                "These Terms are governed by the laws of the United Kingdom. Any disputes shall be subject to the exclusive jurisdiction of the courts located in London-England.",
        },

        contact: {
            title: "13. Contact Us",

            desc1:
                "For questions, support, or legal concerns, please contact:",

            company: "Pareza Limited",

            address:
                "7 Bell Yard, London, England, WC2A 2JR",

            emailLabel: "Email:",
        },
    },


    deleteAccount: {
        title: "How to Permanently Delete Your DazWay Account",

        desc1:
            "Below are the steps to permanently delete your account from the DazWay mobile application:",

        step1:
            "Log in to your DazWay account on the mobile app.",

        step2:
            "Navigate to the Settings page by tapping on the Settings icon located at the bottom right of the screen.",

        step3:
            "Tap on “Delete My Account.”",

        step4:
            "Enter your registered mobile number and verify it using the OTP sent to your number.",

        step5:
            "Select a reason for deleting your account.",

        step6:
            "Tap on “Delete My Account.”",

        step7:
            "In the confirmation popup, tap “OK.”",

        desc2:
            "Once confirmed, your account will be permanently deleted from the DazWay platform.",
    },

    createAndSharePost: {
        newChat: {
            title: "Starting a New Chat",
            intro: "To begin a conversation:",
            step1: "Tap the Chat icon in the bottom navigation bar.",
            step2: "Tap the (+) icon in the center-bottom of the screen.",
            step3: "From the options displayed (Chat, Group+, Meeting), select Chat.",
            step4: "Choose a user from My Contacts (contacts saved in your phonebook).",
            step5: "You will be directed to the chat screen to begin the conversation."
        },
        chatFunc: {
            title: "Chat Functionalities",
            intro: "Once you’re in a chat screen, you can:",
            sendMessagesLabel: "Send Messages",
            sendMessagesDesc: " – Type your message and tap the Send icon.",
            capturePhotoVideoLabel: "Capture Photo/Video",
            capturePhotoVideoDesc: " – Tap the Camera icon, or use Attachment > Camera.",
            shareGalleryMediaLabel: "Share Gallery Media",
            shareGalleryMediaDesc: " – Use Attachment > Gallery.",
            sendDocumentsLabel: "Send Documents",
            sendDocumentsDesc: " – Use Attachment > Document.",
            sendAudioFilesLabel: "Send Audio Files",
            sendAudioFilesDesc: " – Use Attachment > Audio.",
            shareContactsLabel: "Share Contacts",
            shareContactsDesc: " – Use Attachment > Contacts.",
            sendLocationLabel: "Send Location",
            sendLocationDesc: " – Use Attachment > Location.",
            sendEmojisLabel: "Send Emojis",
            sendEmojisDesc: " – Tap the Emoji icon and select any emoji."
        },
        groupChat: {
            title: "Group Chat",
            startIntro: "To start a group chat:",
            startStep1: "Tap the Chat icon in the bottom navigation bar.",
            startStep2: "Tap the (+) icon in the center-bottom of the screen.",
            startStep3: "From the displayed options (Chat, Group+, Meeting), select Group+.",
            startStep4: "Choose multiple users from My Contacts to add to the group.",
            startStep5: "Enter the group name and tap Create Group.",
            startStep6: "You will be redirected to the new group chat screen where you can begin messaging.",
            actionsIntro: "In a group chat, you can:",
            actionStep1: "Send messages, media, documents, and voice notes to all members.",
            actionStep2: "Mention specific members using ",
            actionStep2Suffix: ".",
            actionStep3: "View the list of participants by tapping the Group Info section.",
            actionStep4: "Add or remove members (if you are the group admin).",
            actionStep5: "Customize group name, image, and settings."
        }
    },

    exploreAndViewPost: {
        newCall: {
            title: "Making a New Call",
            intro: "To initiate a new call:",
            step1: "Tap the Call icon in the bottom navigation bar.",
            step2: "Tap the (+) icon in the bottom-right corner.",
            step3: "Select your preferred option: Audio Call, Video Call, or Meeting.",
            step4: "Choose a contact from My Contacts.",
            step5Before: "Tap",
            step5Label: "Call Now",
            step5Desc: "to initiate the call."
        },
        groupCalls: {
            title: "Group Calls",
            intro: "To start a group audio or video call:",
            step1: "Tap the Call icon > (+) icon > Group +.",
            step2: "Select multiple contacts from your list.",
            step3: "Choose",
            step3Strong1: "Audio Call",
            step3Or: "or",
            step3Strong2: "Video Call",
            step4Before: "Tap",
            step4Label: "Call Now",
            step4Desc: "to initiate the group call."
        }
    },

    chatAndCalls: {
        meetings: {
            title: "Meetings",
            intro: "To create or join a meeting:",
            step1: "Tap the Chat or Call icon.",
            step2Before: "Tap the (+) icon and select",
            step2Strong: "Meeting",
            step3: "Enter required meeting details and invite participants.",
            step4Before: "Tap",
            step4Strong1: "Start Meeting",
            step4Or: "or",
            step4Strong2: "Schedule",
            step4Suffix: ", based on availability."
        }
    },

    footer: {
        copyright: "2026 © DazWay Pay Limited"
    }
};